<template>
  <div class="asset-info">
    <div class="asset-info__container">
      <div class="asset-info__header">
        <BackBtn class="asset-info__back" />
        <div class="asset-info__header-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M21 16V8.00002C20.9996 7.6493 20.9071 7.30483 20.7315 7.00119C20.556 6.69754 20.3037 6.44539 20 6.27002L13 2.27002C12.696 2.09449 12.3511 2.00208 12 2.00208C11.6489 2.00208 11.304 2.09449 11 2.27002L4 6.27002C3.69626 6.44539 3.44398 6.69754 3.26846 7.00119C3.09294 7.30483 3.00036 7.6493 3 8.00002V16C3.00036 16.3508 3.09294 16.6952 3.26846 16.9989C3.44398 17.3025 3.69626 17.5547 4 17.73L11 21.73C11.304 21.9056 11.6489 21.998 12 21.998C12.3511 21.998 12.696 21.9056 13 21.73L20 17.73C20.3037 17.5547 20.556 17.3025 20.7315 16.9989C20.9071 16.6952 20.9996 16.3508 21 16Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3.27002 6.96002L12 12.01L20.73 6.96002" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 22.08V12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div>
          <h3 class="asset-info__title">Asset Details</h3>
          <p class="asset-info__subtitle">Enter asset information</p>
        </div>
      </div>
      
      <div class="asset-info__forms">
        <AssetInfoForm @dropdown-title="setActiveDropdown" />
        <div v-if="$route.name === 'ConfigurePrivateRaise' || $route.query.asset">
          <InvestmentMemoForm @dropdown-title="setActiveDropdown" />
          <TokenDetailAddressForm @dropdown-title="setActiveDropdown" />
          <FoundersForm @dropdown-title="setActiveDropdown" />
          <SocialsForm @dropdown-title="setActiveDropdown" />
          <div
            v-if="
              $route.name !== 'ConfigurePrivateRaise' &&
              assetDetails.documents?.length &&
              assetDetails.address &&
              assetDetails.founders?.length &&
              assetDetails.website
            "
            class="asset-info__continue"
          >
            <Btn
              class="asset-info__btn"
              title="Continue"
              @click="$router.push(routeInfo)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import AssetInfoForm from "@/components/asset/forms/AssetInfoForm";
import InvestmentMemoForm from "@/components/asset/forms/InvestmentMemoForm";
import TokenDetailAddressForm from "@/components/asset/forms/TokenDetailAddressForm";
import FoundersForm from "@/components/asset/forms/FoundersForm";
import SocialsForm from "@/components/asset/forms/SocialsForm";
import BackBtn from "@/components/general/BackBtn";
import Btn from "@/components/general/BtnComponent";
import { computed } from "vue-demi";

export default {
  name: "CreateAssetInfo",

  components: {
    AssetInfoForm,
    InvestmentMemoForm,
    TokenDetailAddressForm,
    FoundersForm,
    SocialsForm,
    Btn,
    BackBtn,
  },

  data() {
    return {
      activeDropdown: "",
    };
  },

  computed: {
    ...mapState({
      orgDetails: (state) => state.organisationModule.organisationDetails,
      assetDetails: (state) => state.assetModule.assetDetails,
    }),

    routeInfo() {
      switch (this.$route.params.type) {
        case "public-raise":
          // if (this.assetDetails.type === "Company") {
          //   return { name: "CreateAsset", params: { type: "public-raise" } };
          // }
          return {
            name: "CreatePublicRaise",
            query: {
              asset:
                this.orgDetails.type === "Community"
                  ? this.$route.query.asset
                  : "",
            },
          };

        case "employee-benefits":
          return { name: "CreateStockOptions" };
        case "private-raise":
          return {
            name: "PrivateRaiseRequest",
            query: {
              asset: this.$route.query.asset
                ? this.$route.query.asset
                : this.assetDetails._id,
            },
          };

        default:
          break;
      }
    },
  },

  provide() {
    return {
      activeDropdown: computed(() => this.activeDropdown),
    };
  },
  created() {
    if (this.$route.params.type === "private-raise") {
      this.getLastRaiseStage();
    }
  },

  methods: {
    ...mapActions("organisationModule", ["getLastRaiseStage"]),
    setActiveDropdown(title) {
      this.activeDropdown = title;
    },
  },
};
</script>

<style lang="scss" scoped>
.asset-info {
  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  
  &__container {
    max-width: 870px;
    margin: 0 auto;
  }
  
  &__header {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 32px;
  }
  
  &__back {
    display: none;
    
    @media (min-width: 640px) {
      display: block;
    }
  }
  
  &__header-icon {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #4D84FF 0%, #6B9AFF 100%);
    border-radius: 12px;
    color: #ffffff;
    flex-shrink: 0;
  }
  
  &__title {
    font-size: 20px;
    font-weight: 500;
    color: #0F172A;
    margin: 0 0 4px 0;
  }
  
  &__subtitle {
    font-size: 14px;
    color: #64748B;
    margin: 0;
  }
  
  &__forms {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
  
  &__continue {
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;
  }
  
  &__btn {
    min-width: 180px;
    
    @media (min-width: 768px) {
      min-width: 208px;
    }
  }
}

// Override form section styling
:deep(.form-section),
:deep(.tw-bg-white) {
  background: #ffffff;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  padding: 24px;
}

:deep(label) {
  font-size: 13px;
  font-weight: 500;
  color: #64748B;
}

:deep(input),
:deep(select),
:deep(textarea) {
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  font-size: 14px;
  transition: all 0.2s ease;
  
  &:focus {
    border-color: #4D84FF;
    box-shadow: 0 0 0 3px rgba(77, 132, 255, 0.1);
    outline: none;
  }
}
</style>
